import { render, staticRenderFns } from "./broadcast.vue?vue&type=template&id=3d9b801e&scoped=true&"
import script from "./broadcast.vue?vue&type=script&lang=js&"
export * from "./broadcast.vue?vue&type=script&lang=js&"
import style0 from "./broadcast.vue?vue&type=style&index=0&id=3d9b801e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b801e",
  null
  
)

export default component.exports